import React from "react";


const HotelListItemSkeleton = () => {
  return (
    <div className="hw-hotel--filterResult__listItem">
      <div className="hw-hotel--filterResult__listItemLeft">
        {/* Main Image Skeleton */}
        <div className="hw-hotel--filterResult__listItemMimage">
          <div className="hw-hotel--listItemm">
            <div 
              className="skeleton-item"
              style={{
                width: "100%",
                height: "200px",
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                animation: "skeleton-pulse 1.5s ease-in-out infinite",
              }}
            />
          </div>
        </div>
        <div className="hw-hotel--filterResult__listItemTimage">
          {[1, 2, 3, 4, 5].map((i) => (
            <div className="item" key={i}>
              <div className="hw-hotel--listItemt">
                <div
                  className="skeleton-item"
                  style={{
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "4px",
                    animation: "skeleton-pulse 1.5s ease-in-out infinite",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="hw-hotel--filterResult__listItemRight">
        <div className="hw-hotel--filterResult__listItemRightWrapper">
          <div className="hw-hotel--filterResult__listItemInfo">
            <div className="hw-hotel--filterResult__review">
              <div className="d-flex hw-gapy4">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div
                    key={i}
                    className="skeleton-item"
                    style={{
                      width: "16px",
                      height: "16px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "2px",
                      animation: "skeleton-pulse 1.5s ease-in-out infinite",
                    }}
                  />
                ))}
              </div>
            </div>
            <div className="hw-hotel--filterResult__title">
              <div
                className="skeleton-item"
                style={{
                  width: "80%",
                  height: "24px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  marginBottom: "8px",
                  animation: "skeleton-pulse 1.5s ease-in-out infinite",
                }}
              />
              <div
                className="skeleton-item"
                style={{
                  width: "60%",
                  height: "24px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  animation: "skeleton-pulse 1.5s ease-in-out infinite",
                }}
              />
            </div>
            <div className="hw-hotel--filterResult__location">
              <div
                className="skeleton-item"
                style={{
                  width: "200px",
                  height: "16px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  marginBottom: "12px",
                  animation: "skeleton-pulse 1.5s ease-in-out infinite",
                }}
              />
            </div>
            
            {/* View Details Link Skeleton */}
            <div
              className="skeleton-item"
              style={{
                width: "150px",
                height: "16px",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                marginBottom: "16px",
                animation: "skeleton-pulse 1.5s ease-in-out infinite",
              }}
            />
            <ul className="hw-hotel--filterResult__iconText list-unstyled">
              {[1, 2, 3].map((i) => (
                <li key={i} style={{ marginBottom: "8px" }}>
                  <div className="d-flex align-items-center hw-gapy8">
                    <div
                      className="skeleton-item"
                      style={{
                        width: "16px",
                        height: "16px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "50%",
                        animation: "skeleton-pulse 1.5s ease-in-out infinite",
                      }}
                    />
                    <div
                      className="skeleton-item"
                      style={{
                        width: `${80 + Math.random() * 60}px`,
                        height: "16px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                        animation: "skeleton-pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  </div>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="hw-hotel--filterResult__listItemSelect">
            <div className="flex-shrink--null">
              {/* Review Section Skeleton */}
              <div className="hw-rating--tool">
                <div
                  className="skeleton-item"
                  style={{
                    width: "120px",
                    height: "40px",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "4px",
                    animation: "skeleton-pulse 1.5s ease-in-out infinite",
                  }}
                />
              </div>
            </div>
            
            <div>
              {/* Price Skeleton */}
              <div className="h4 text-right">
                <div
                  className="skeleton-item"
                  style={{
                    width: "100px",
                    height: "28px",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "4px",
                    marginLeft: "auto",
                    marginBottom: "8px",
                    animation: "skeleton-pulse 1.5s ease-in-out infinite",
                  }}
                />
              </div>
              
              {/* Room Info Skeleton */}
              <div className="hw-text14 hw-fontWeight--500 text-right">
                <div
                  className="skeleton-item"
                  style={{
                    width: "80px",
                    height: "16px",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "4px",
                    marginLeft: "auto",
                    marginBottom: "10px",
                    animation: "skeleton-pulse 1.5s ease-in-out infinite",
                  }}
                />
              </div>
              
              {/* Button Skeleton */}
              <div className="hw-mt--10">
                <div
                  className="skeleton-item"
                  style={{
                    width: "100%",
                    height: "48px",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "4px",
                    animation: "skeleton-pulse 1.5s ease-in-out infinite",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelListItemSkeleton;
